import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPlateApi } from "../../http/carPlates/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteCarPlateDialogProps = {
  carPlateId: string;
  carId?: string;
  onClose: (success?: boolean) => void;
};

const DeleteCarPlateDialog: FC<DeleteCarPlateDialogProps> = ({ carPlateId, carId, onClose }) => {
  const i18n = useI18n();
  const carPlatesApi = useCarPlateApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.carPlates.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carPlatesApi
              .deleteAdminCarPlate(carPlateId, carId)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .then(() => onClose(true))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.carPlates.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarPlateDialog;
